import * as React from 'react';
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {AccountDetailsBanner} from "../../../../components/banners/AccountDetailsBanner";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    Party,
    Policy,
    POLICY_STATUS_MTC,
    ProductsEnum,
    Types,
    User
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {PersonalDetailsWidget} from "../../../../components/accountDetails/PersonalDetailsWidget";
import {ContactDetailsWidget} from "../../../../components/accountDetails/ContactDetailsWidget";
import {AddressDetailsWidget} from "../../../../components/accountDetails/AddressDetailsWidget";
import {ChangePasswordWidget} from "../../../../components/accountDetails/ChangePasswordWidget";
import {
    AutomaticRenewalCheckboxSection
} from "../../common/payments/paymentDetails/annual/AutomaticRenewalCheckboxSection";
import {getProductByPolicyNumber} from "../../../../CommonFunctions";
import * as moment from "moment";
import {AllianzOnlineBadge} from "../../../../components/AllianzOnlineBadge";

interface IDashboardParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    party?: Party;
    policy?: Policy;
    user?: User;
}

@authorize
export class AnnualHomeAccountDetailsPagePlain extends React.Component<IWithRouterProps<IDashboardParams>, IState> {

    private pluginTemplates = new PluginTemplates();
    private product: ProductsEnum;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IDashboardParams>) {
        super(props);

        this.state = {}

        this.product = getProductByPolicyNumber(this.props.params.policyNumber);
    }

    public componentDidMount(): void {
        {window.scrollTo(0, 0)}

        this.customerPortalService
            .getPolicy(this.props.params.policyNumber)
            .subscribe((policy: Policy) => {
                this.setState({policy})
            })

        this.customerPortalService.getProfile().subscribe((party: Party) => {
            this.setState({
                party
            })
        });

        this.customerPortalService.getUserById().subscribe((user: User) => {
            this.setState({
                user
            });
        });

        this.pluginTemplates.setPageTitle("Your account details");
    }

    public render(): React.ReactNode {
        const backLinkUrl: string = `/dashboard/annualHome/${this.props.params.policyNumber}`;

        if (!this.state.party || !this.state.policy || !this.state.user) {
            return <Overlay show={true}/>
        } else {
            const endDate: moment.Moment = moment.utc(this.state.policy.endDate);
            const mtaOnEndDateOfPolicy: boolean = endDate.isSame(moment.utc(this.state.policy.annualPolicyInfo.maxFutureMtaDate), 'day');
            const coverLapsed: boolean = moment.utc().isAfter(endDate);

            return (
                <>
                    <FalconHeader/>
                    <div className="plugin account-details-container">
                        <AllianzOnlineBadge/>
                        <FalconNavigatorHeader
                            back={backLinkUrl}
                            title="Account details"
                        />
                        <AccountDetailsBanner/>
                        <div className="plugin plugin-panel inner-container inner-content text-center account-details-section">
                            <div className="panel-detail-output-entity account-details-title p-0 icon-container">
                                <div>
                                    <img className="account-details-icon person-icon" alt="make-changes" src="/img/account-details.svg"/>
                                </div>
                            </div>
                            <div>
                                <PersonalDetailsWidget party={this.state.party}/>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                <ContactDetailsWidget party={this.state.party} hasIdp={this.state.party.hasIdp}/>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                <AddressDetailsWidget addressChangeUrl={`/journey/show/product/AnnualHomeInsurance/process/mta/presetPage/${this.state.policy?.interaction._id}`}
                                                      allowAddressChange={!this.state.policy?.annualPolicyInfo.hasUnpaidChargebackInvoice}
                                                      futureMta={this.state.policy?.annualPolicyInfo.maxMtaDateReached}
                                                      fullAddress={this.state.policy?.interaction.policyHolder.address.fullAddress}
                                                      coverCancelled={this.state.policy?.status === POLICY_STATUS_MTC}
                                                      coverLapsed={(mtaOnEndDateOfPolicy || coverLapsed)}
                                />
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                {this.state.user && !this.state.party.hasIdp && <ChangePasswordWidget/>}
                            </div>
                        </div>
                        {this.state.policy?.status !== POLICY_STATUS_MTC &&
                            <AutomaticRenewalCheckboxSection
                                navigate={this.props.navigate}
                                activeAnnualPolicy={this.state.policy}
                                product={this.product}
                            />
                        }
                        {this.pluginTemplates.renderBackLink("Back", true, backLinkUrl)}
                    </div>
                    <FalconFooter/>
                </>
            )
        }
    }
}

export const AnnualHomeAccountDetailsPage = withRouter<{}, IDashboardParams>(AnnualHomeAccountDetailsPagePlain)
